module.exports = __webpack_public_path__ + "img/proton.37a86e97.svg";